export default {
    currency: kitBuilderData.currency,
    kitId: kitBuilderData.id.length ? kitBuilderData.id : false,
    lists: kitBuilderData?.lists,
    step: false,
    current: false,
    cart: kitBuilderData.cart ? JSON.parse(kitBuilderData.cart) : {}
}